<div class="menu">
	<p class="menu-btn" (click)="goBack()">
		<img src="/assets/common/back.png" class="menu-btn-icon" alt="" />
		Back
	</p>
</div>
<hr />
<div class="loading" [class.loading--active]="!isLoading">Loading...</div>
<div *ngIf="quest">
	<app-map
		[lat]="quest.lat"
		[lng]="quest.lng"
		[userLat]="userLocation.lat"
		[userLng]="userLocation.lng"
	></app-map>
	<div class="title-holder">
		<h2>{{ quest.ConciseLocation }}</h2>
		<p>|</p>
		<p class="time">{{ quest.RequestUnixTime | date }}</p>
	</div>
	<div class="tag-holder">
		<span class="tag" *ngFor="let tag of tagList">{{ tag }}</span>
	</div>
	<button
		(click)="acceptMission(quest.MissionId)"
		class="acceptBtn btn-style"
	>
		Accept
	</button>
</div>
